import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { RdsBreadcrumbsModule } from '@rds/angular-components';
import { StoryblokDirective } from '../../../directives/storyblok.directive';

@Component({
  selector: 'inexp-sb-breadcrumbs',
  imports: [StoryblokDirective, RdsBreadcrumbsModule],
  templateUrl: './sb-breadcrumbs.component.html',
  styleUrl: './sb-breadcrumbs.component.scss',
})
export class SbBreadcrumbsComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  content = input<any[]>([]);

  items = computed(() =>
    (this.content() ?? []).map((b) => ({
      text: b.title,
      link: b.link,
    }))
  );

  navigate(breadcrumbItem: any) {
    this.router.navigate([breadcrumbItem.link], {
      queryParams: breadcrumbItem.queryParams ?? {},
    });
  }

}
